export class CookieConfig {
    url = './assets/configurations/cookie.json';
}
